import { z } from 'zod';

export interface CustomizationThemeDto {
  id: number;
  name: string;
  category: string;
  description: string;
  logoGradientColors: string[];
  accentGradientColors: string[];
  deletedAt?: number;
}

export const CreateCustomizationThemeSchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    category: z.string().min(1, 'Category is required'),
    description: z.string().min(1, 'Description is required'),
    logoGradientColors: z
      .array(z.string())
      .min(1, 'At least one logo color is required'),
    accentGradientColors: z
      .array(z.string())
      .min(1, 'At least one accent color is required'),
  })
  .strict();

export const UpdateCustomizationThemeSchema = z
  .object({
    name: z.string().min(1).optional(),
    category: z.string().min(1).optional(),
    description: z.string().min(1).optional(),
    logoGradientColors: z.array(z.string()).min(1).optional(),
    accentGradientColors: z.array(z.string()).min(1).optional(),
    deletedAt: z.number().nullable().optional(),
  })
  .strict();

export type CreateCustomizationThemeRequest = z.infer<
  typeof CreateCustomizationThemeSchema
>;
export type UpdateCustomizationThemeRequest = z.infer<
  typeof UpdateCustomizationThemeSchema
>;
